export { ConsentProvider, useConsentManager } from './consentManager'
